"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GET_LEGACY_USER_ID = exports.DELETE_ACCOUNT = exports.DEACTIVATE_ACCOUNT = exports.SET_TOKEN = exports.SET_VENDOR_TOKEN = exports.SET_ROUTE = exports.RESET_ROUTE = exports.SEND_PASSWORD_RESET_INSTRUCTIONS = exports.SEND_ACCOUNT_ACTIVATION_INSTRUCTIONS = exports.RESET_AUTHENTICATION_KEEP_ROUTE = exports.RESET_AUTHENTICATION = exports.LOGIN = exports.GET_USER = exports.GET_ACCOUNT = exports.CLEAR_AUTHENTICATION_ERROR = void 0;
const LOGIN = 'authentication/LOGIN';
exports.LOGIN = LOGIN;
const GET_USER = 'authentication/GET_USER';
exports.GET_USER = GET_USER;
const GET_ACCOUNT = 'authentication/GET_ACCOUNT';
exports.GET_ACCOUNT = GET_ACCOUNT;
const GET_LEGACY_USER_ID = 'authentication/GET_LEGACY_USER_ID';
exports.GET_LEGACY_USER_ID = GET_LEGACY_USER_ID;
const SEND_PASSWORD_RESET_INSTRUCTIONS = 'authentication/SEND_PASSWORD_RESET_INSTRUCTIONS';
exports.SEND_PASSWORD_RESET_INSTRUCTIONS = SEND_PASSWORD_RESET_INSTRUCTIONS;
const SEND_ACCOUNT_ACTIVATION_INSTRUCTIONS = 'authentication/SEND_ACCOUNT_ACTIVATION_INSTRUCTIONS';
exports.SEND_ACCOUNT_ACTIVATION_INSTRUCTIONS = SEND_ACCOUNT_ACTIVATION_INSTRUCTIONS;
const RESET_AUTHENTICATION = 'authentication/RESET';
exports.RESET_AUTHENTICATION = RESET_AUTHENTICATION;
const RESET_AUTHENTICATION_KEEP_ROUTE = 'authentication/RESET_AUTHENTICATION_KEEP_ROUTE';
exports.RESET_AUTHENTICATION_KEEP_ROUTE = RESET_AUTHENTICATION_KEEP_ROUTE;
const CLEAR_AUTHENTICATION_ERROR = 'authentication/CLEAR_ERROR';
exports.CLEAR_AUTHENTICATION_ERROR = CLEAR_AUTHENTICATION_ERROR;
const SET_ROUTE = 'authentication/SET_ROUTE';
exports.SET_ROUTE = SET_ROUTE;
const SET_TOKEN = 'authentication/SET_TOKEN';
exports.SET_TOKEN = SET_TOKEN;
const SET_VENDOR_TOKEN = 'authentication/SET_VENDOR_TOKEN';
exports.SET_VENDOR_TOKEN = SET_VENDOR_TOKEN;
const RESET_ROUTE = 'authentication/RESET_ROUTE';
exports.RESET_ROUTE = RESET_ROUTE;
const DEACTIVATE_ACCOUNT = 'authentication/DEACTIVATE_ACCOUNT';
exports.DEACTIVATE_ACCOUNT = DEACTIVATE_ACCOUNT;
const DELETE_ACCOUNT = 'authentication/DELETE_ACCOUNT';
exports.DELETE_ACCOUNT = DELETE_ACCOUNT;
//# sourceMappingURL=index.js.map